import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const networkTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Network',
  key: 'NETWORK',
  main: {
    metadata: {
      layout: {
        rows: [
          [
            'id',
          ],
          [
            'networkId',
          ],
          [
            'networkIdHint',
          ],
          [
            'ownIPAddress',
          ],
          [
            'startPortNumber',
          ],
          [
            'portNumberRange',
          ],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      networkId: {
        label: 'Network ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 16,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      networkIdHint: {
        type: 'custom',
        placeholder: 'Max 16 characters with no spaces',
        customComponent: 'networkIdHint',
        className: 'field-desc',
      },
      ownIPAddress: {
        label: 'Local IP Address',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 50,
            },
            {
              type: 'IPAddress',
              invalidIPs: ['255.255.255.255'],
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
          ],
        },
      },
      startPortNumber: {
        label: 'Starting Port Number',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [[0, 65535]],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.',
            },
            {
              type: 'triggerValidationOnAnotherField',
              theOtherField: 'portNumberRange',
            },
          ],
        },
      },
      portNumberRange: {
        label: 'Port Number Range',
        type: 'text',
        initial: '1',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'customFunction',
              customValidationFunction: 'portNumberRangeValidator',
              errorMessage: 'Must be between 1 - {{end}}. Please re-enter.',
            },
          ],
        },
      },
    },
  },
};
